import { cn } from '@/lib/utils'

export interface NavigationItem {
  label: string
  href: string
  isActive?: boolean
}

export interface MainNavProps {
  items: NavigationItem[]
  onNavigate?: (href: string) => void
}

/**
 * Segmented pill navigation for the four SONAR sections.
 * Active tab is a raised white pill with a small amber accent dot.
 */
export function MainNav({ items, onNavigate }: MainNavProps) {
  return (
    <nav className="inline-flex items-center gap-1 rounded-full bg-stone-100 p-1 dark:bg-stone-800/70">
      {items.map((item) => (
        <button
          key={item.href}
          type="button"
          onClick={() => onNavigate?.(item.href)}
          aria-current={item.isActive ? 'page' : undefined}
          className={cn(
            'flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors',
            item.isActive
              ? 'bg-white text-stone-900 shadow-sm ring-1 ring-stone-900/5 dark:bg-stone-950 dark:text-white'
              : 'text-stone-500 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100',
          )}
        >
          {item.isActive && <span className="h-1.5 w-1.5 rounded-full bg-champagne-500" aria-hidden />}
          {item.label}
        </button>
      ))}
    </nav>
  )
}

export default MainNav
